import { useContext, useEffect } from "react";
import { PageHeadingContext } from "@osu/react-ui";

function AuthenticationComponent({ Component, title }) {
  const { setHeading } = useContext(PageHeadingContext);
  useEffect(() => {
    title && setHeading(title);
  }, [setHeading, title]);
  

  return <Component />;
}

export default AuthenticationComponent;
